const estimateFlags = (incoming) => ({
  stalled: Boolean(incoming?.stalled),
  delayed: Boolean(incoming?.delayed),
  stalledReason: incoming?.stalled_reason || null,
});

export const remainingWaitSeconds = (state, now = Date.now()) => {
  if (!state || state.estimatedSeconds == null || !state.fetchedAt) return null;
  return Math.max(0, Number(state.estimatedSeconds) - Math.floor((now - state.fetchedAt) / 1000));
};

export const adoptWaitEstimate = (previous, incoming, now = Date.now()) => {
  const flags = estimateFlags(incoming);
  const incomingSeconds = Number(incoming?.estimated_seconds);
  const incomingRevision = incoming?.queue_revision ?? incoming?.revision ?? null;
  if (!(incomingSeconds >= 0)) {
    if (!flags.stalled && !flags.delayed) return previous || null;
    return {
      estimatedSeconds: previous?.estimatedSeconds ?? null,
      fetchedAt: previous?.fetchedAt ?? now,
      revision: incomingRevision ?? previous?.revision ?? null,
      ...flags,
    };
  }

  const hasPrevious = Boolean(previous && previous.estimatedSeconds != null && previous.fetchedAt);
  if (!hasPrevious) {
    return {
      estimatedSeconds: incomingSeconds,
      fetchedAt: now,
      revision: incomingRevision,
      ...flags,
    };
  }

  const previousRevision = previous.revision ?? null;
  const revisionKnown = incomingRevision != null && previousRevision != null;
  if (revisionKnown && incomingRevision !== previousRevision) {
    return {
      estimatedSeconds: incomingSeconds,
      fetchedAt: now,
      revision: incomingRevision,
      ...flags,
    };
  }

  const remaining = remainingWaitSeconds(previous, now);
  if (remaining != null && incomingSeconds < remaining) {
    return {
      estimatedSeconds: incomingSeconds,
      fetchedAt: now,
      revision: incomingRevision ?? previousRevision,
      ...flags,
    };
  }

  return {
    ...previous,
    revision: incomingRevision ?? previousRevision,
    ...flags,
  };
};
